/**
 * Set custom properties for the height of the eyebrow and primary navigation
 *
 * @param eyebrowMenuHeight
 * @param stickyNavigationHeight
 */
const setDefaultProperties = (eyebrowMenuHeight, stickyNavigationHeight) => {
	document.documentElement.style.setProperty("--wp-eyebrow-menu-height", eyebrowMenuHeight + "px");

	document.documentElement.style.setProperty("--wp-sticky-navigation-height", stickyNavigationHeight + "px");
};

/**
 * Sets custom property for scroll padding height of anchor links
 *
 * Group blocks with sticky positioning are not accounted for in the scroll padding height. If a group block is sticky, the height of the group block is added height of the main navigation so the content is not hidden behind the sticky content.
 *
 * @param stickyNavigationHeight
 */
const setScrollPaddingHeight = (stickyNavigationHeight) => {
	const stickyGroup = document.querySelector(".wp-block-group.is-position-sticky");

	if (!stickyGroup) {
		return;
	}

	const stickyGroupHeight = stickyGroup.offsetHeight;

	document.documentElement.style.setProperty("--wp-scroll-padding-top", stickyNavigationHeight + stickyGroupHeight);
};

/**
 * Initialize the custom properties
 */
const init = () => {
	const eyebrowMenu = document.getElementById("eyebrow-menu-container");
	const stickyNavigation = document.getElementById("neo4j-main-menu-container");
	const blogNavigation = document.querySelector(".neo4j-blog-navigation");

	if (eyebrowMenu) {
		setDefaultProperties(eyebrowMenu.offsetHeight, stickyNavigation.offsetHeight);
	}
	if (stickyNavigation) {
		setScrollPaddingHeight(stickyNavigation.offsetHeight);
	}
	if (blogNavigation) {
		const blogNavHeight = blogNavigation.offsetHeight;
		document.documentElement.style.setProperty("--wp-blog-nav-height", `${blogNavHeight}px`);
	}
};

window.addEventListener("DOMContentLoaded", () => {
	init();
});
